import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  mutation DeleteAdminAgentKnowledgeBaseFile(
    $input: AdminAgentKnowledgeBaseFileTargetInput!
  ) {
    deleteAdminAgentKnowledgeBaseFile(input: $input)
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.DeleteAdminAgentKnowledgeBaseFileMutation,
    boolean,
    'deleteAdminAgentKnowledgeBaseFile'
  >('deleteAdminAgentKnowledgeBaseFile', transformers.PASS_THROUGH),
)

export const execute = graphql.createExecutor<
  graphql.schema.DeleteAdminAgentKnowledgeBaseFileMutation,
  boolean,
  graphql.schema.DeleteAdminAgentKnowledgeBaseFileMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
